import { Button, Card, Input, InputNumber, Space } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { FC } from 'react';

export type ChapterItem = {
	title: string;
	page: number;
	order: number;
	items?: ChapterItem[];
};

interface IProps {
	value?: ChapterItem[];
	onChange: (items: ChapterItem[]) => void;
	level?: number;
}

export const ChapterItemsTree: FC<IProps> = ({ value = [], onChange, level = 1 }) => {
	const maxLevel = 3;

	function updateItem(index: number, field: keyof ChapterItem, fieldValue: any) {
		const newItems = [...value];
		newItems[index] = {
			...newItems[index],
			[field]: fieldValue,
		};

		onChange(newItems);
	}

	function updateChildren(index: number, children: ChapterItem[]) {
		const newItems = [...value];
		newItems[index] = {
			...newItems[index],
			items: children,
		};

		onChange(newItems);
	}

	function addItem() {
		onChange([
			...value,
			{
				title: '',
				page: 1,
				order: value.length + 1,
				items: [],
			},
		]);
	}

	function removeItem(index: number) {
		const newItems = value.filter((_, itemIndex) => itemIndex !== index);
		onChange(newItems);
	}

	return (
		<div style={{ marginLeft: level > 1 ? 24 : 0 }}>
			{value.map((item, index) => (
				<Card
					key={`${level}-${index}`}
					size='small'
					style={{ marginBottom: 12 }}
					title={`Nível ${level} - Item ${index + 1}`}
					extra={
						<Button danger size='small' icon={<DeleteOutlined />} onClick={() => removeItem(index)} />
					}
				>
					<Space direction='vertical' style={{ width: '100%' }}>
						<Input
							placeholder='Título'
							value={item.title}
							onChange={(event) => updateItem(index, 'title', event.target.value)}
						/>

						<Space>
							<InputNumber
								addonBefore='Página'
								placeholder='Página'
								min={1}
								value={item.page}
								onChange={(value) => updateItem(index, 'page', Number(value || 1))}
							/>

							<InputNumber
								addonBefore='Ordem'
								placeholder='Ordem'
								min={1}
								value={item.order}
								onChange={(value) => updateItem(index, 'order', Number(value || 1))}
							/>
						</Space>

						{level < maxLevel && (
							<ChapterItemsTree
								value={item.items || []}
								level={level + 1}
								onChange={(children) => updateChildren(index, children)}
							/>
						)}
					</Space>
				</Card>
			))}

			<Button type='dashed' icon={<PlusOutlined />} onClick={addItem}>
				Adicionar item no nível {level}
			</Button>
		</div>
	);
};
